import matter from "gray-matter";

import categoryConfig from "./categories";
import { categorySlug, legacySlug, articleSlug, articleOrder } from "../../lib/helpSlug";

/**
 * Every help article, bundled at build time.
 *
 * Shape: [{ slug, dir, title, icon, description, badge, subtopics, articles }]
 * where each article is { id, slug, legacySlug, file, order, title,
 * subcategory, content, category: { slug, title } }.
 *
 * Categories come out in `categories.js` order; articles by their number, then
 * file name, so two files that share a number (Order & Payments had two `12-`)
 * still render in a stable order.
 */
function readArticles() {
  const ctx = require.context(__dirname, true, /\.md$/);
  const byDir = {};

  ctx.keys().forEach(key => {
    const [dir, file] = key.substring(2).split("/");
    const parsed = matter(ctx(key).default);

    if (!byDir[dir]) byDir[dir] = [];
    byDir[dir].push({
      slug: articleSlug(file),
      legacySlug: legacySlug(file),
      file,
      order: articleOrder(file),
      title: parsed.data.title,
      subcategory: parsed.data.subcategory || null,
      content: parsed.content
    });
  });

  return byDir;
}

function compareArticles(a, b) {
  if (a.order !== b.order) return a.order - b.order;
  return a.file < b.file ? -1 : 1;
}

const articlesByDir = readArticles();

const categories = categoryConfig.map(config => {
  const slug = categorySlug(config.dir);
  const category = { slug, title: config.title };
  const articles = (articlesByDir[config.dir] || [])
    .slice()
    .sort(compareArticles)
    .map(article => ({ ...article, id: `${slug}/${article.slug}`, category }));

  return { ...config, slug, articles };
});

export default categories;

export function findCategory(slug) {
  return categories.find(category => category.slug === slug) || null;
}

export function findArticle(categorySlugValue, slug) {
  const category = findCategory(categorySlugValue);
  if (category === null) return null;

  return category.articles.find(article => article.slug === slug) || null;
}

export function allArticles() {
  return categories.reduce((all, category) => all.concat(category.articles), []);
}
